// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.titleContainer {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    margin-bottom: -1em;
}

.title {
    color: var(--infoColor);
}

.iconWarning {
    animation: iconPulse 1.5s ease-in-out infinite;
}

@keyframes iconPulse {
    0% {
        transform: scale(1.0)
    }
    100% {
        transform: scale(1.8)
    }
}

.card {
    max-height: 200px;
    background-color: whitesmoke;
    overflow-x: hidden;
}

.card:hover {
    color: whitesmoke;
    background-color: var(--primaryColor);
    transition: 0.3s ease-in-out;
    transform: scale(1.02);
}

.card:not(:hover) {
    transition: 0.3s;
    transform: scale(1);
}


.inlineContainer {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    margin-top: -0.4em;
}

.imageWarning {
    border-bottom: 3px solid orange;
}

.imageDanger {
    border-bottom: 3px solid var(--dangerColor);
}

.imageOkay {
    border-bottom: 3px solid var(--primaryColor);
}

.cardWarning {
    max-height: 200px;
    border: 4px solid orange;
    margin: -4px;
    overflow-x: hidden;
}

.cardWarning:hover {
    color: whitesmoke;
    background-color: orange;
    transition: 0.3s ease-in-out;
    transform: scale(1.01);
}

.cardWarning:hover .cardWarningText {
    color: whitesmoke;
    font-weight: bold;
}

.cardCritical {
    max-height: 200px;
    border: 4px solid var(--dangerColor);
    margin: -4px;
    animation: pulse 2s infinite;
    overflow-x: hidden;
}

.cardCritical:hover {
    color: whitesmoke;
    background-color: var(--dangerColor);
    transition: 0.3s ease-in-out;
    transform: scale(1.01);
}

.cardCritical:hover .cardCriticalText {
    color: whitesmoke;
    font-weight: bold;
}

.cardWarningText {
    color: orange;
    font-weight: bold;
}

.cardCriticalText {
    color: var(--dangerColor);
    font-weight: bold;
}

.tableRow:hover {
    background-color: whitesmoke;
}

@keyframes pulse {
    0% {
        transform: scale(1.02);
        box-shadow: 0 0 0 0 rgba(255, 0, 0, 0.7);
    }

    70% {
        transform: scale(1);
        box-shadow: 0 0 0 10px rgba(255, 0, 0, 0);
    }

    100% {
        transform: scale(1.02);
        box-shadow: 0 0 0 0 rgba(255, 0, 0, 0);
    }
}`, "",{"version":3,"sources":["webpack://./src/pages/stock_management/layout/StockManagementUI.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,8CAA8C;AAClD;;AAEA;IACI;QACI;IACJ;IACA;QACI;IACJ;AACJ;;AAEA;IACI,iBAAiB;IACjB,4BAA4B;IAC5B,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;IACjB,qCAAqC;IACrC,4BAA4B;IAC5B,sBAAsB;AAC1B;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;AACvB;;;AAGA;IACI,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,2CAA2C;AAC/C;;AAEA;IACI,4CAA4C;AAChD;;AAEA;IACI,iBAAiB;IACjB,wBAAwB;IACxB,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;IACjB,wBAAwB;IACxB,4BAA4B;IAC5B,sBAAsB;AAC1B;;AAEA;IACI,iBAAiB;IACjB,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;IACjB,oCAAoC;IACpC,YAAY;IACZ,4BAA4B;IAC5B,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;IACjB,oCAAoC;IACpC,4BAA4B;IAC5B,sBAAsB;AAC1B;;AAEA;IACI,iBAAiB;IACjB,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,iBAAiB;AACrB;;AAEA;IACI,yBAAyB;IACzB,iBAAiB;AACrB;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI;QACI,sBAAsB;QACtB,wCAAwC;IAC5C;;IAEA;QACI,mBAAmB;QACnB,yCAAyC;IAC7C;;IAEA;QACI,sBAAsB;QACtB,sCAAsC;IAC1C;AACJ","sourcesContent":[".titleContainer {\n    display: flex;\n    align-items: center;\n    flex-wrap: wrap;\n    margin-bottom: -1em;\n}\n\n.title {\n    color: var(--infoColor);\n}\n\n.iconWarning {\n    animation: iconPulse 1.5s ease-in-out infinite;\n}\n\n@keyframes iconPulse {\n    0% {\n        transform: scale(1.0)\n    }\n    100% {\n        transform: scale(1.8)\n    }\n}\n\n.card {\n    max-height: 200px;\n    background-color: whitesmoke;\n    overflow-x: hidden;\n}\n\n.card:hover {\n    color: whitesmoke;\n    background-color: var(--primaryColor);\n    transition: 0.3s ease-in-out;\n    transform: scale(1.02);\n}\n\n.card:not(:hover) {\n    transition: 0.3s;\n    transform: scale(1);\n}\n\n\n.inlineContainer {\n    display: flex;\n    align-items: center;\n    flex-wrap: wrap;\n    margin-top: -0.4em;\n}\n\n.imageWarning {\n    border-bottom: 3px solid orange;\n}\n\n.imageDanger {\n    border-bottom: 3px solid var(--dangerColor);\n}\n\n.imageOkay {\n    border-bottom: 3px solid var(--primaryColor);\n}\n\n.cardWarning {\n    max-height: 200px;\n    border: 4px solid orange;\n    margin: -4px;\n    overflow-x: hidden;\n}\n\n.cardWarning:hover {\n    color: whitesmoke;\n    background-color: orange;\n    transition: 0.3s ease-in-out;\n    transform: scale(1.01);\n}\n\n.cardWarning:hover .cardWarningText {\n    color: whitesmoke;\n    font-weight: bold;\n}\n\n.cardCritical {\n    max-height: 200px;\n    border: 4px solid var(--dangerColor);\n    margin: -4px;\n    animation: pulse 2s infinite;\n    overflow-x: hidden;\n}\n\n.cardCritical:hover {\n    color: whitesmoke;\n    background-color: var(--dangerColor);\n    transition: 0.3s ease-in-out;\n    transform: scale(1.01);\n}\n\n.cardCritical:hover .cardCriticalText {\n    color: whitesmoke;\n    font-weight: bold;\n}\n\n.cardWarningText {\n    color: orange;\n    font-weight: bold;\n}\n\n.cardCriticalText {\n    color: var(--dangerColor);\n    font-weight: bold;\n}\n\n.tableRow:hover {\n    background-color: whitesmoke;\n}\n\n@keyframes pulse {\n    0% {\n        transform: scale(1.02);\n        box-shadow: 0 0 0 0 rgba(255, 0, 0, 0.7);\n    }\n\n    70% {\n        transform: scale(1);\n        box-shadow: 0 0 0 10px rgba(255, 0, 0, 0);\n    }\n\n    100% {\n        transform: scale(1.02);\n        box-shadow: 0 0 0 0 rgba(255, 0, 0, 0);\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
